
        import i18n from 'i18n';
        import flattenObject from 'util/flattenObject';
    
            import ns376fbae3e57ead5a66ed6ccfb232498een from './en.yaml'
            i18n.addResourceBundle('en', '376fbae3e57ead5a66ed6ccfb232498e', flattenObject(ns376fbae3e57ead5a66ed6ccfb232498een), true, true);
        
        export default '376fbae3e57ead5a66ed6ccfb232498e';
    